/* TLR Homepage Reviews + Trust Block JS
   Ported from approved mockup at tlr-mockups.vercel.app/reviews-section
   2026-05-02
*/
(function () {
  'use strict';

  var SECTION_ROOT = '.lr-reviews-section';

  function init(root) {
    if (!root || root.dataset.lrInitialized === '1') return;
    root.dataset.lrInitialized = '1';

    initJdgmCarousel(root);
    initBrandMarquee(root);
    initTrustScroll(root);
    initMobileTitleSwap(root);
  }

  /* ============================================================
     1. JDGM CAROUSEL: take over JDGM's static item-wrapper as our marquee track.
        Run RAF auto-scroll, hover-pause, swipe, arrow nudge.
     ============================================================ */
  function initJdgmCarousel(root) {
    var poll = 0;
    var iv = setInterval(function () {
      poll++;
      var track = root.querySelector('.jdgm-carousel__item-wrapper');
      var items = root.querySelectorAll('.jdgm-carousel-item');
      if (track && items.length > 0) {
        clearInterval(iv);
        attachCarousel(root, track);
      } else if (poll > 80) {
        clearInterval(iv);
      }
    }, 100);
  }

  function attachCarousel(root, track) {
    // Duplicate items once for a seamless loop: [0..N) and [N..2N) are identical.
    var originals = Array.from(track.children);
    if (originals.length === 0) return;
    var originalCount = originals.length;
    originals.forEach(function (node) { track.appendChild(node.cloneNode(true)); });

    var pos = 0;
    var lastTime = 0;
    var SPEED = 30; // px/sec desktop auto-marquee
    var hoverPaused = false;
    var manualPaused = false;
    var manualPauseTimer = null;

    function smallScreen() { return window.innerWidth <= 900; }

    function stepWidth() {
      var card = track.querySelector('.jdgm-carousel-item');
      if (!card) return 0;
      return card.offsetWidth + (parseFloat(getComputedStyle(track).gap) || 0);
    }
    // One loop period = exactly N original cards. Wrapping by N*step (NOT scrollWidth/2,
    // which carries the wrapper's padding + a leftover gap) keeps every wrap landing on a
    // clean card boundary. With scrollWidth/2 the pos drifted off-card after the first wrap,
    // so snaps stopped mid-review and the wrap animated as a "skip + autoscroll".
    function period() { return originalCount * stepWidth(); }

    function setTransform() { track.style.transform = 'translate3d(' + (-pos) + 'px, 0, 0)'; }

    // Reset pos into [0, period). Identical cloned content makes this invisible — but ONLY
    // when no transition is active, else the browser animates the full-period jump.
    function normalize() {
      var p = period();
      if (p > 0) { while (pos >= p) pos -= p; while (pos < 0) pos += p; }
    }

    function scheduleResume(delay) {
      clearTimeout(manualPauseTimer);
      manualPauseTimer = setTimeout(function () {
        track.style.transition = '';
        manualPaused = false;
      }, delay || 2500);
    }

    function tick(now) {
      if (lastTime === 0) lastTime = now;
      var dt = Math.min(0.05, (now - lastTime) / 1000);
      lastTime = now;
      // Auto-marquee is desktop-only; on mobile it rests on a card so each swipe advances
      // exactly one review. Wrap here is instant (transition is '') so it stays seamless.
      if (!hoverPaused && !manualPaused && !smallScreen()) {
        pos += SPEED * dt;
        normalize();
        setTransform();
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    var frame = root.querySelector('.lr-carousel-frame');
    if (frame) {
      frame.addEventListener('mouseenter', function () { hoverPaused = true; });
      frame.addEventListener('mouseleave', function () { hoverPaused = false; });
    }

    // Animate exactly one card from the boundary nearest `fromPos`. The target may land on a
    // clone (period, or -step); the next touchstart/tick normalizes it back instantly.
    function snapFrom(fromPos, dir, ms) {
      var step = stepWidth();
      if (step <= 0) return;
      var base = Math.round(fromPos / step);
      pos = (base + dir) * step;
      track.style.transition = 'transform ' + (ms || 380) + 'ms cubic-bezier(.22,.61,.36,1)';
      setTransform();
    }

    function nudge(dir) {
      if (stepWidth() <= 0) return;
      manualPaused = true;
      snapFrom(pos, dir, 550);
      scheduleResume(7000);
    }

    var prev = root.querySelector('.lr-arrow--prev');
    var next = root.querySelector('.lr-arrow--next');
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });

    // Touch swipe — ONE swipe = ONE review. CAPTURE + stopPropagation suppress JDGM's native
    // swipe (bound on .jdgm-carousel inside our frame); that double-binding was the original
    // "stuck after one swipe". preventDefault only on committed horizontal intent so vertical
    // page scroll and product-link taps survive. touchstart normalizes instantly so any
    // pending wrap is resolved off-card before the gesture begins.
    var touchStartX = 0, touchStartY = 0, touchStartPos = 0, touching = false, horiz = false;
    if (frame) {
      frame.addEventListener('touchstart', function (e) {
        e.stopPropagation();
        if (e.touches.length !== 1) return;
        touching = true;
        horiz = false;
        manualPaused = true;
        track.style.transition = '';
        normalize();                 // resolve any pending wrap instantly (invisible)
        setTransform();
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartPos = pos;
        clearTimeout(manualPauseTimer);
      }, { capture: true, passive: true });
      frame.addEventListener('touchmove', function (e) {
        e.stopPropagation();
        if (!touching) return;
        var x = e.touches[0].clientX;
        var dx = x - touchStartX;
        var dy = e.touches[0].clientY - touchStartY;
        if (!horiz && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) horiz = true;
        if (horiz) {
          if (e.cancelable) e.preventDefault();
          pos = touchStartPos - dx;          // 1:1 finger tracking during the drag
          setTransform();
        }
      }, { capture: true, passive: false });
      frame.addEventListener('touchend', function (e) {
        e.stopPropagation();
        if (!touching) return;
        touching = false;
        if (horiz) {
          var dxTotal = e.changedTouches[0].clientX - touchStartX;
          var dir = dxTotal <= -40 ? 1 : (dxTotal >= 40 ? -1 : 0);
          snapFrom(touchStartPos, dir, 380);   // one review from the gesture's start card
        }
        scheduleResume(2500);
      }, { capture: true, passive: true });
    }
  }

  /* ============================================================
     2. BRAND MARQUEE (dealer panel) RAF scroll
     ============================================================ */
  function initBrandMarquee(root) {
    var tracks = root.querySelectorAll('.lr-brand-marquee__track');
    tracks.forEach(function (track) {
      if (track.dataset.rafStarted === '1') return;
      track.dataset.rafStarted = '1';
      track.style.animation = 'none';
      var pos = 0;
      var lastTime = 0;
      var SPEED = 53; // px/sec, ~90s for full cycle
      function tick(now) {
        if (lastTime === 0) lastTime = now;
        var dt = Math.min(0.05, (now - lastTime) / 1000);
        lastTime = now;
        var halfWidth = track.scrollWidth / 2;
        if (halfWidth > 0) {
          pos += SPEED * dt;
          if (pos >= halfWidth) pos -= halfWidth;
          track.style.transform = 'translate3d(' + (-pos) + 'px, 0, 0)';
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  /* ============================================================
     3. TRUST SCROLLYTELLING (desktop) + tap-toggle (mobile)
     ============================================================ */
  function initTrustScroll(root) {
    root.querySelectorAll('.lr-trust-scroll').forEach(function (scrollRoot) {
      var rail = scrollRoot.querySelector('.lr-trust-scroll__rail');
      var panels = Array.from(scrollRoot.querySelectorAll('.lr-trust-scroll__panel'));
      var pills = Array.from(scrollRoot.querySelectorAll('.lr-trust-scroll__pill'));
      if (!rail || !panels.length) return;

      var lastActive = -1;
      function setActive(i) {
        if (i === lastActive) return;          // idempotent: don't re-toggle every scroll frame
        lastActive = i;
        // Class toggle only — the CSS transitions (photo height .7s, content fade-up) animate
        // the open, so scroll-driven activation opens smoothly, same as a tap.
        panels.forEach(function (p, idx) { p.classList.toggle('is-active', idx === i); });
        pills.forEach(function (p, idx) { p.classList.toggle('is-active', idx === i); });
      }
      function clearActive() {
        lastActive = -1;
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        pills.forEach(function (p) { p.classList.remove('is-active'); });
      }

      function isMobile() { return window.innerWidth <= 900; }

      // DESKTOP: sticky-pin scrollytelling driven by rail progress.
      function onScrollDesktop() {
        var r = rail.getBoundingClientRect();
        var span = r.height - window.innerHeight;
        if (span <= 0) return;
        var progress = Math.min(1, Math.max(0, -r.top / span));
        var slice = 1 / panels.length;
        var i = Math.min(panels.length - 1, Math.max(0, Math.floor(progress / slice)));
        setActive(i);
      }

      // Height of any sticky/fixed site header pinned at the top, so a scrolled-to panel
      // doesn't hide its photo under it.
      function stickyHeaderOffset() {
        var best = 0;
        document.querySelectorAll('header, .header, .header-wrapper, sticky-header, [class*="header"]').forEach(function (h) {
          var s = getComputedStyle(h);
          if (s.position === 'fixed' || s.position === 'sticky') {
            var r = h.getBoundingClientRect();
            if (r.top <= 2 && r.height > best && r.height < 220) best = r.height;
          }
        });
        return best;
      }
      // Bring an opened panel up so its photo sits at the top of the viewport. Wait for the
      // photo's height transition to finish first so the layout has settled (any panel above
      // that just collapsed has finished shrinking) — then the scroll target is accurate.
      function scrollPanelIntoView(panel) {
        var photo = panel.querySelector('.lr-trust-scroll__photo');
        var done = false;
        function go() {
          if (done) return;
          done = true;
          var y = window.pageYOffset + panel.getBoundingClientRect().top - stickyHeaderOffset() - 10;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
        if (photo) {
          photo.addEventListener('transitionend', function te(ev) {
            if (ev.propertyName === 'height') { photo.removeEventListener('transitionend', te); go(); }
          });
        }
        setTimeout(go, 820); // fallback if transitionend doesn't fire
      }

      // MOBILE: tap-to-open accordion (the approved design). NO scroll-driven activation —
      // expanding a panel grows it ~370px, and doing that mid-scroll fights the phone's
      // momentum, which felt violent and skipped panels. Tapping a card opens it in place;
      // the CSS transitions animate it open, then we gently scroll it up so the photo is at
      // the top of the screen and the whole box is framed.
      panels.forEach(function (panel) {
        panel.addEventListener('click', function (e) {
          if (!isMobile()) return;
          if (e.target.closest('.lr-trust-scroll__cta')) return;   // let the CTA link work
          if (panel.classList.contains('is-active')) {
            clearActive();                              // tap the open card to collapse it
          } else {
            setActive(panels.indexOf(panel));           // open this one, close the others
            scrollPanelIntoView(panel);                 // frame it with the photo at top
          }
        });
        panel.style.cursor = 'pointer';
      });

      var ticking = false;
      function onScroll() {
        if (isMobile() || ticking) return;   // mobile is tap-only; desktop = scrollytelling
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          onScrollDesktop();
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });

      function syncMode() {
        clearActive();                         // reset on load + real mode change
        if (!isMobile()) onScrollDesktop();    // desktop: derive active from scroll; mobile: all compact
      }
      syncMode();
      // Only re-sync when the mobile/desktop breakpoint actually flips. Mobile browsers fire
      // `resize` when the address bar shows/hides DURING scroll (innerHeight changes); calling
      // clearActive() on those was collapsing the open panel every time you scrolled.
      var wasMobile = isMobile();
      window.addEventListener('resize', function () {
        var nowMobile = isMobile();
        if (nowMobile === wasMobile) return;
        wasMobile = nowMobile;
        syncMode();
      });

      // Pill clicks (desktop only): scroll to that panel.
      pills.forEach(function (pill, idx) {
        pill.addEventListener('click', function () {
          if (isMobile()) return;
          var r = rail.getBoundingClientRect();
          var span = rail.offsetHeight - window.innerHeight;
          var target = window.scrollY + r.top + (span * (idx + 0.5)) / panels.length;
          window.scrollTo({ top: target, behavior: 'smooth' });
        });
      });
    });
  }

  /* ============================================================
     4. MOBILE TITLE SWAP
     Compact card shows pill label, expanded shows full title.
     ============================================================ */
  function initMobileTitleSwap(root) {
    var panels = root.querySelectorAll('.lr-trust-scroll__panel');
    panels.forEach(function (panel) {
      var titleEl = panel.querySelector('.lr-trust-scroll__content-title');
      var pillLabel = panel.dataset.pillLabel;
      if (!titleEl || !pillLabel) return;
      titleEl.dataset.fullTitle = titleEl.textContent;
      titleEl.dataset.shortTitle = pillLabel;
    });

    function refresh() {
      var isMobile = window.innerWidth <= 900;
      panels.forEach(function (panel) {
        var titleEl = panel.querySelector('.lr-trust-scroll__content-title');
        if (!titleEl || !titleEl.dataset.fullTitle) return;
        var compact = !panel.classList.contains('is-active');
        titleEl.textContent = (isMobile && compact) ? titleEl.dataset.shortTitle : titleEl.dataset.fullTitle;
      });
    }
    refresh();
    window.addEventListener('resize', refresh);
    panels.forEach(function (panel) {
      new MutationObserver(refresh).observe(panel, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ============================================================
     BOOTSTRAP
     ============================================================ */
  function boot() {
    document.querySelectorAll(SECTION_ROOT).forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_ROOT);
    if (section) {
      delete section.dataset.lrInitialized;
      init(section);
    }
  });
})();
